import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import baseURL from '../../../../Apiurs/Apiurls';
import Navbar from '../../../../Shared/AdminNavbar/Navbar';


const StockHistory = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [history, setHistory] = useState([]);
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [collapsed, setCollapsed] = useState(false); // State for sidebar toggle

  useEffect(() => {
    fetchData();
  }, [id]);

  const fetchData = async () => {
    try {
      const [productRes, historyRes] = await Promise.all([
        axios.get(`${baseURL}/api/product/${id}`),
        axios.get(`${baseURL}/api/stock/history/${id}`),
      ]);

      setProduct(productRes.data);
      setHistory(historyRes.data);
    } catch (err) {
      console.error('Error fetching data:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="container mt-4">Loading...</div>;

  return (
    <div className="CollapseContainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`Collapse ${collapsed ? 'collapsed' : ''}`}>
        <div className="container mt-4">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <div>
                <h4>Stock History - {product?.batch}</h4>
                <p className="mb-0">Size: {product?.size} | Current Stock: {product?.Quantity || 0}</p>
              </div>
              <button
                className="btn btn-secondary"
                onClick={() => navigate('/products')}
              >
                Back to Products
              </button>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Action</th>
                      <th>Qty Change</th>
                      <th>Previous Qty</th>
                      <th>New Qty</th>
                      <th>Reason</th>
                      <th>Reference</th>
                      <th>Notes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {history.map((record) => (
                      <tr key={record.id}>
                        <td>{new Date(record.created_at).toLocaleString()}</td>
                        <td>
                          <span
                            className={`badge ${
                              record.action_type === 'stock_in'
                                ? 'bg-success'
                                : 'bg-danger'
                            }`}
                          >
                            {record.action_type}
                          </span>
                        </td>
                        <td
                          className={
                            record.action_type === 'stock_in'
                              ? 'text-success'
                              : 'text-danger'
                          }
                        >
                          {record.action_type === 'stock_in' ? '+' : '-'}{record.quantity_change}
                        </td>
                        <td>{record.previous_quantity}</td>
                        <td>{record.new_quantity}</td>
                        <td>{record.reason}</td>
                        <td>{record.reference_number || '-'}</td>
                        <td>{record.notes || '-'}</td>
                      </tr>
                    ))}
                    {history.length === 0 && (
                      <tr>
                        <td colSpan="8" className="text-center">
                          No stock history found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockHistory;